// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/x-mark.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/x-mark'

import { Icon, type IconComponentProps } from '../icon'

export const XMarkIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
